module.exports = __webpack_public_path__ + "img/icon_coordinates10.824d1e91.png";